import React from "react";

import { Images } from "../config";

const GetProPopup = () => {
  return (
    <div className="rounded-[1.75em] drop-shadow-md bg-white flex flex-col justify-center items-center gap-4 text-black p-5">
      <img src={Images.GetProYellow} className="h-[4.125em]" />
      <div className="text-[1.5em] font-bold text-center">
        To View More Get <span className="text-main">Univision</span>
        <br /> Pro Version!
      </div>
      <div
        className="flex gap-2 bg-getProOrange rounded-lg p-3 items-center cursor-pointer"
        onClick={() => localStorage.setItem("showPaymentPage", true)}
      >
        <div className="font-semibold text-[0.875em]">Get UniVision Pro</div>
        <img src={Images.GetPro} className="h-[0.875em]" />
      </div>
    </div>
  );
};

export default GetProPopup;
